export default __webpack_public_path__ + "static/media/Carosel P 3.ecbcd376.svg";